handleUserRequestCountry